import {getSubscriptions, cancelSubscription} from "@/api/subscription";

const state = {
    subscription: {
        data: [],
        has_more: false,
        current_page: 1,
        starting_after: null,
    }
}

const getters = {
    subscriptions: state => state.subscription.data,
    has_more: state => state.subscription.has_more,
    current_page: state => state.subscription.current_page,
}

const mutations = {
    SET_SUBSCRIPTION_DATA: (state, payload) => {
        state.subscription.has_more = payload.meta.current_page < payload.meta.last_page;
        state.subscription.current_page = payload.meta.current_page;
        if (payload.data.length > 0) {
            state.subscription.starting_after = payload.data[payload.data.length - 1].id;
        }

        if (state.subscription.data.length === 0) {
            state.subscription.data = payload.data;
        } else {
            state.subscription.data = state.subscription.data.concat(payload.data);
        }
    },

    CLEAR_SUBSCRIPTION_DATA: (state) => {
        state.subscription.data = [];
        state.subscription.has_more = false;
        state.subscription.starting_after = null;
    },

    SET_CANCELLED_SUBSCRIPTION_STATUS: (state, id) => {
        state.subscription.data = state.subscription.data.map(subscription => {
            if (subscription.id === id) {
                subscription.status = 'cancelled';
            }
            return subscription;
        });
    }
}

const actions = {
    clearState({commit}) {
        commit('CLEAR_SUBSCRIPTION_DATA');
    },

    getSubscriptions({commit, state}, page = 1) {
        return new Promise((resolve, reject) => {
            getSubscriptions(page, state.subscription.starting_after)
                .then(response => {
                    commit('SET_SUBSCRIPTION_DATA', response);
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    cancelSubscription({commit}, subscriptionId) {
        return new Promise((resolve, reject) => {
            cancelSubscription(subscriptionId)
                .then(response => {
                    commit('SET_CANCELLED_SUBSCRIPTION_STATUS', subscriptionId);
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
